import React, { useEffect, useState } from 'react'
import { Box, DialogContent } from '@mui/material'

import { useMarketersCalls } from '../../hooks'
import { MarketerZones } from '../zones'

export const MarketerEditDialogComponent = ({ close, marketerId, rowData }) => {
  const { getMarketer } = useMarketersCalls()

  const [formState, setFormState] = useState({})

  useEffect(() => {
    getMarketer(rowData['id']).then(({ data }) => {
      setFormState({
        ...formState,
        mercados: data.filtros.mercados,
        provincias: data.filtros.provincias,
        cps: data.filtros.cod_codigo_postal,
      })
    })
  }, [rowData.id])

  return (
    <Box p={2}>
      <DialogContent>
        {
          <MarketerZones
            {...{
              marketerId: marketerId,
              formState: formState,
              close,
            }}
          />
        }
      </DialogContent>
    </Box>
  )
}
